import { render, staticRenderFns } from "./customMoudle.vue?vue&type=template&id=5d2d3c7f&scoped=true&"
import script from "./customMoudle.vue?vue&type=script&lang=js&"
export * from "./customMoudle.vue?vue&type=script&lang=js&"
import style0 from "./customMoudle.vue?vue&type=style&index=0&id=5d2d3c7f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2d3c7f",
  null
  
)

export default component.exports